import Layout from "@/views/Backend/Project/Layout"

const adminProjectRouters = {
  path: "/admin/project/:projectId",
  component: Layout,
  name: "admin-project",
  redirect: "/admin/project/:projectId/info",
  children: [
    // basic
    {
      path: "info",
      component: () => import("@/views/Backend/Project/Basic/Info"),
      name: "admin-project-info"
    },
    {
      path: "operation",
      component: () => import("@/views/Backend/Project/Basic/Operation"),
      name: "admin-project-operation"
    },
    {
      path: "robot",
      component: () => import("@/views/Backend/Project/Basic/Robot"),
      name: "admin-project-robot"
    },
    // task
    {
      path: "task/approval",
      component: () => import("@/views/Backend/Project/Task/Approval"),
      name: "admin-project-task-approval"
    },
    {
      path: "task/setting",
      component: () => import("@/views/Backend/Project/Task/Setting"),
      name: "admin-project-task-setting"
    },
    {
      path: "task/authority",
      component: () => import("@/views/Backend/Project/Task/Authority"),
      name: "admin-project-task-authority"
    },
    {
      path: "task/remind",
      component: () => import("@/views/Backend/Project/Task/Remind"),
      name: "admin-project-task-remind"
    },
    {
      path: "task/template",
      component: () => import("@/views/Backend/Project/Task/Template"),
      name: "admin-project-task-template"
    },
    {
      path: "task/group",
      component: () => import("@/views/Backend/Project/Task/Group"),
      name: "admin-project-task-group"
    },
    // user
    {
      path: "user/member",
      component: () => import("@/views/Backend/Project/User/Member"),
      name: "admin-project-user-member"
    },
    {
      path: "user/role",
      component: () => import("@/views/Backend/Project/User/Role"),
      name: "admin-project-user-role"
    },
    // statistics
    {
      path: "statistics",
      component: () => import("@/views/Backend/Project/Statistics"),
      name: "admin-project-statistics"
    }
  ]
}

export default adminProjectRouters
